import React from "react";

import { css } from "@emotion/css";
import { CellContext } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";

import { useStyles } from "@/hooks/useStyles.ts";
import { CarePlan, TelemonitoringTier, getTelemonitoringTierTranslation } from "@/models/CarePlanModel.ts";
import { Typography } from "@/uiKit/atoms/Typography.tsx";

export type TelemonitoringTierColumnProps = CellContext<CarePlan, TelemonitoringTier>;

export const TelemonitoringTierColumn: React.FC<TelemonitoringTierColumnProps> = ({ getValue }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <Typography className={styles.container} variant="body">
      {t(getTelemonitoringTierTranslation(getValue()))}
    </Typography>
  );
};

const makeStyles = () => ({
  container: css({}),
});
